import React, {Component} from 'react';
import Criterials from '../../general/criterials';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import swal from 'sweetalert';

import Inputmask from 'inputmask'
import { Typeahead } from 'react-bootstrap-typeahead';
import { FloatingActionButton } from 'material-ui';
import { ContentAdd } from 'material-ui/svg-icons';
import SvgIcon from 'react-icons-kit';
import {priceTag} from 'react-icons-kit/icomoon/priceTag';

var Config = require('../../../../config');

class Form extends Component{
	constructor(props){
		super(props);

		this.getData = this.getData.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.partsChange = this.partsChange.bind(this);
		this.getCryoData = this.getCryoData.bind(this);
		this.inputsChange = this.inputsChange.bind(this);
		this.removeFocus = this.removeFocus.bind(this);
		this.clearFields = this.clearFields.bind(this);
		this.checkAllColumns = this.checkAllColumns.bind(this);
		this.changeVolume = this.changeVolume.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.searchComponent = this.searchComponent.bind(this);
		this.addToList = this.addToList.bind(this);
		this.printLabel = this.printLabel.bind(this);

		var aux_date = new Date();
			
		this.state = {
			date : aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			hour : "",
			cryoprecipitates:[],
			parts:[],

			checks:[],
			crio_pl_default_vol:{},
			crio_cr_default_vol:{},
			search:"date",

			code_component_list:[],
			isLoading:false,
			unit_number_required:false,
			unit_number:"",
			aux_cryoprecipitates:[],
			component:"",
			pending:true,
			units:[],
			preview_print:{},
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		var selector = document.getElementById('hour');
		var im = new Inputmask("--:--");
		im.mask(selector);

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		});

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=CRIO_PL_DEFAULT_VOL&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				crio_pl_default_vol: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=CRIO_CR_DEFAULT_VOL&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				crio_cr_default_vol: response
			});
		})

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			
			this.setState({
				hour:hours,
			});
		})
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		var campo = e.target.name;
		this.setState({
			[campo]: e.target.value
		});

		if(campo === 'hour'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		}else{
			setTimeout(function(){
				this.showCtrlError(campo);
			}.bind(this), 500);
		}	
	}

	getData(result){
		
		result.blood_components.map((res)=>{
			res.checked =  true

		});

		result.units.map((unit)=>{
			unit.default_crio_vol = this.state.crio_cr_default_vol.value;
			
			unit.default_pl_vol = parseInt(unit.unit.volume) - parseInt(unit.default_crio_vol);

		});

		this.setState({
			cryoprecipitates: result,
		});

		setTimeout(function(){
			this.inputRef.focus();
		}.bind(this), 500);
	}

	partsChange(e){
		this.state.parts.map((p,i)=>{
			return p.id === parseInt(e.target.id)?
				p.value = e.target.value
			:null
		});

		this.forceUpdate();
	}

	showCtrlError(refName){
		var res = null;
		var control = document.getElementById(refName);

		if (this.state[refName] === "") {
			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	getCryoData(){
		var obj = {};
		var date = moment(this.state.date.split('-').reverse().join('/'), 'DD-MM-YYYY');
		var hour = moment(this.state.hour, 'h:mm a');
		var cryo = [];
		var error = "";

		obj.date = date.format('MM-DD-YYYY');;
		obj.hour = this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm');

		var error_vol = "";
		var error_lock ="";
		if(this.state.cryoprecipitates.units !== undefined){
			this.state.cryoprecipitates.units.map((u, i)=>{
				if(document.getElementById('unit_'+u.unit.id) !==null){
					var row = document.getElementById('unit_'+u.unit.id).checked;
					var vol = parseInt(u.unit.volume);

					var vol_component = 0;
					this.state.cryoprecipitates.blood_components.map((c)=>{

						var all = document.getElementById('all_'+c.id).checked
						var check = document.getElementById('check_'+u.unit.id+'_'+c.id).checked;

						if(check && row){
							var val = document.getElementById(u.unit.id+'_'+c.id).value;

							if(val === '' || parseInt(val) === 0){
								error = "error_valor"
							}else if(val !== ""){
								cryo.push({
									unit_id: parseInt(u.unit.id),
									volume: parseInt(val),
									blood_component_id: parseInt(c.id)
								});

								vol_component += parseInt(val)

								if(u.status === 'BLOQUEADA'){
									if(error_lock.indexOf(u.unit.unit_number) === -1){
										error_lock += u.unit.unit_number+', ';
									}
								}
							}
						}
						/*
						if(row && all){
							var val = document.getElementById(u.unit.id+'_'+c.id).value
							if(val === "" || parseInt(val) === 0){
								error = "error_valor"
							}else if(val !== ""){
								cryo.push({
									unit_id: parseInt(u.unit.id),
									volume:  parseInt(val),
									blood_component_id: parseInt(c.id)
								});

								vol_component += parseInt(val)
							}
						}*/
					})

					if(vol !== vol_component && row){
						error_vol += u.unit.unit_number+', ';
					}
				}
			});
		}
			

		if(error_vol !== ""){
			obj.error_vol = error_vol;
		}else{
			obj.error_vol = "";
		}

		if(error_lock !== ""){
			obj.error_lock = error_lock;
		}

		if(error !== ""){
			obj.cryoprecipitate_parts = error;
		}else{
			obj.cryoprecipitate_parts = cryo;
		}
		
		return obj;
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){	
  					if(form.elements[index + 1].getAttribute("disabled") === null){	
    					if(form.elements[index + 1].getAttribute("type") === 'checkbox'){
							form.elements[index + 1].focus();
							form.elements[index + 1].style.boxShadow = "0 0 5px 2px rgb(104, 173, 253)";
    					
    					}else{
    						form.elements[index + 1].focus();
    					}
    					
  					}else if(form.elements[index + 1].getAttribute("disabled") === ""){
    					form.elements[index + 2].focus();
    				}
      				
      			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	removeFocus(e){
  		e.target.style.boxShadow = "0 0 5px 2px rgb(255, 255, 255)";
  	}

  	inputsChange(e){
  		var id = e.target.id;

  		this.state.cryoprecipitates.units.map((u)=>{
  			var row = document.getElementById('unit_'+u.unit.id).checked;

  			this.state.cryoprecipitates.blood_components.map((c)=>{
  				var all = document.getElementById('all_'+c.id).checked;

  				if(id === 'header_'+c.id){
  					if(all){
  						if(row){
  							var val = document.getElementById('header_'+c.id).value;
  							document.getElementById(u.unit.id+'_'+c.id).value = val;
  						}
  					}
  				}
  			})

  		})

  	}

  	clearFields(e){
  		var id = parseInt(e.target.id.split('_')[1]);
			var check = e.target.checked;
			
			if(this.state.cryoprecipitates.units !== undefined){
				this.state.cryoprecipitates.units.map((u)=>{

					this.state.cryoprecipitates.blood_components.map((c)=>{
						//var all = document.getElementById('all_'+c.id).checked

						if(u.unit.id === id /*&& !all*/){
							

							if(!check){
								document.getElementById(u.unit.id+'_'+c.id).value = "";	
							}else{
								document.getElementById(u.unit.id+'_'+c.id).value = c.component_type === 'CRIOPRECIPITADOS' ? u.default_crio_vol:
																		c.component_type === 'PLASMA' ? u.default_pl_vol : "";
							}
							
							document.getElementById('check_'+u.unit.id+'_'+c.id).checked = check ? true : false;
						
						}
					})
				})
			}
  		
		}
	
	checkAllColumns(e){
		var id = parseInt(e.target.id.split('_')[1]);
		var check = e.target.checked;
	
		this.state.cryoprecipitates.units.map((u)=>{
			this.state.cryoprecipitates.blood_components.map((obj) => {
				if(document.getElementById('unit_'+u.unit.id) !== null){
					if(e.target.id === "all_check"){
						
						document.getElementById('unit_'+u.unit.id).checked = check ? true : false;
						document.getElementById('check_'+u.unit.id+'_'+obj.id).checked = check ? true : false;
						document.getElementById('all_'+obj.id).checked = check ? true : false;
						
					}else{
						if(obj.id === id){
							document.getElementById('check_'+u.unit.id+'_'+obj.id).checked = check ? true : false;
						}
					}
				}
					
			})
		});

		this.forceUpdate();

	}

	changeVolume(e){
		var crios = this.state.cryoprecipitates;
		var id_unit = parseInt(e.target.id.split('_')[0]);
		var id_component = parseInt(e.target.id.split('_')[1]);

		var index_u = crios.units.findIndex(obj => obj.unit.id === id_unit);

		var index_c = crios.blood_components.findIndex(obj => obj.id === id_component);

		if(crios.blood_components[index_c].component_type === 'CRIOPRECIPITADOS'){
			crios.units[index_u].default_crio_vol = e.target.value;
		}

		if(crios.blood_components[index_c].component_type === 'PLASMA'){
			crios.units[index_u].default_pl_vol = e.target.value;
		}

		this.setState({cryoprecipitates: crios});


	}

	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			//this.validateInput(e);

			fetch(Config.default.apiGateway.URL+'units/cryoprecipitate_search?unit_number='+e.target.value+
				'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then(msg=>{
						swal("Error", msg, 'error')
					});

					document.getElementById('unit_number').focus();
				}
			})
			.then(response=>{
				if(response !== undefined){
					var code = [];
					response.units.map((unit)=>{
						code.push({
							label: unit.component.code
						});

						unit.default_crio_vol = this.state.crio_cr_default_vol.value;
						
						unit.default_pl_vol = parseInt(unit.unit.volume) - parseInt(unit.default_crio_vol);
					})


					this.setState({
						aux_cryoprecipitates: response,
						code_component_list: code
					})
					
					this._typeahead.getInstance().focus();
				}

			})

		}
	}

	onSearch(e){
		if(e.length > 0){
			this.setState({component: e[0].label});
		}
	}

	addToList(e){
		e.preventDefault();

		var aux_cryoprecipitates = this.state.aux_cryoprecipitates;
		var cryoprecipitates = this.state.cryoprecipitates;
		aux_cryoprecipitates.units.map((unit)=>{
			if(unit.component.code === this.state.component && unit.unit.unit_number === this.state.unit_number){
				if(cryoprecipitates.units === undefined){
					cryoprecipitates = {
						blood_components: aux_cryoprecipitates.blood_components,
						units: []
					};
				}
				
				var index = cryoprecipitates.units.findIndex(obj => obj.unit.unit_number === this.state.unit_number);
			
				if(index === -1){
					
					cryoprecipitates.units.push(unit);
				}else{
					swal('Error', 'La unidad ya se encuentra en la tabla', 'error');
				}
				
			}
		});

		if(cryoprecipitates.units.length > 0){
			this.setState({
				cryoprecipitates: cryoprecipitates,
				unit_number:"",
				component:"",
				code_component_list:[]
			});

			this._typeahead.getInstance().clear();
		}
	}

	printLabel(e){
		if(e !== ''){
			e.preventDefault();
		}
		
		//this.props.waiting.handleShow('Imprimiendo...');
          
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea imprimir etiquetas?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Imprimir!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    },  (isConfirm)=> {
	        if (isConfirm) {
				fetch(Config.default.apiGateway.URL+'labelsEditor/print_bag_labels?health_facilities_id='+
					sessionStorage.getItem('health_facilities_id'), {
					method : 'post',
					body:JSON.stringify(this.state.units),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.blob();
					}else{
						res.text().then(function(result) {
							swal('¡Error!', result, 'error');
							return;
						});
					}
				}).then(response => {
					if(response !== undefined){
						if(this.state.preview_print.value === "NO"){
							//PREVIEW
							var fileURL = URL.createObjectURL(response);
							window.open(fileURL);
						}else{
							//PRINTER
							var reader = new FileReader();
							reader.readAsDataURL(response); 
							reader.onloadend = ()=> {
								var base64data = reader.result;  
								var aux = base64data.split(',');
								this.props.socket.send('{"Operacion":"print", "Type":"label_bags", "File": "'+aux[1]+'"}');
							}
						}

					}
				});
			}
		});
	}

	render(){
		return (
			<div className="col-xs-12">
				<fieldset>
					<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Búsqueda</legend>
					<div className="col-xs-12 col-sm-1">
						<span className="span-min">Buscar por</span>
						<select className="form-control" name="search" id="search" value={this.state.search} onChange={this.handleChange}>
							<option value="date">Fecha</option>
							<option value="unit">Unidad</option>
						</select>								
					</div>
					<div className="col-xs-12 col-sm-11">
						{this.state.search === 'date' ?
							<Criterials {...this.props} validate={this.validateInput} sendData={this.getData}  
								search={this.state.search}
								onRef={ref => (this.criterials = ref)}
							/>
						: <div className="col-xs-12 col-sm-12">
							<div className="col-xs-12">
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">No de Unidad</span>
									<input className={this.state.unit_number_required ? "form-control error" : "form-control"} type="text" 
										id = "unit_number" name="unit_number" onKeyPress={(e) => this.searchComponent(e)} onChange={this.handleChange}
										value={this.state.unit_number || ""} />
								</div>

								<div className="col-xs-12 col-sm-2" style={{paddingLeft:"0px"}}>
									<span className="span-min">Código componente</span>
									<Typeahead
										/*{...this.state}*/
										labelKey={(option) => `${option.label}`}
										minLength={0}
										options={this.state.code_component_list.length > 0 ? this.state.code_component_list : []}
										onChange={this.onSearch}	
										inputProps={{
											name:"code_component",
											id:"code_component",
											autoComplete:'off'
										}}
										id="codeComponent"
										autoComplete="off"
										isLoading={this.state.isLoading}
										ref={ref => this._typeahead = ref}
										delay={600}
										paginationText="Mostrar mas resultados..."
									/>

								</div>
								<div className="col-xs-12 col-sm-2" style={{marginTop:'18px'}}>
									<FloatingActionButton className="action-btn" mini={true}
										iconStyle={{height: 25, width: 25}} onClick={this.addToList} >
										<ContentAdd/>
									</FloatingActionButton> 
								</div>
							</div>
						</div>
						}
					</div>
					
				</fieldset>

				<fieldset>
					<legend style={{fontSize:"1.5em", marginBottom:"10px"}}>Proceso</legend>

					<div className="col-xs-12 col-sm-9 col-sm-offset-2">
						<div className="col-xs-12 form-group">
							<div className="col-xs-12" style={{width:"4.5%", padding:"0"}}>
								<span>Fecha</span>
							</div>
							<div className="col-xs-12 col-sm-2" style={{padding:"0"}}>
								<input className="form-control" type="date" id="date" name="date" ref={(input) => { this.inputRef = input }}
									onChange={this.handleChange} value={this.state.date || ""} onKeyPress={(e) => this.validateInput(e)} required />
							</div>

							<div className="col-xs-12 col-sm-1" style={{paddingLeft:"19px"}}>
								<span>Hora</span>
							</div>
							<div className="col-xs-12 col-sm-2" style={{padding:"0", width:"14.2%"}}>
								<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
									data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
									required onKeyPress={(e)=>this.validateInput(e)} className="form-control"/>
								
							</div>

						</div>
					</div>

					<div className="col-xs-12 col-sm-9 col-sm-offset-2 form-group">
						<div className="col-xs-12 col-sm-11">
							<Table responsive hover>
								<thead>
									<tr>
										<th>
											{this.state.cryoprecipitates.blood_components !== undefined ?
												this.state.cryoprecipitates.blood_components.length > 0 ?
													
													<input type="checkbox" name={"all_check"} id={"all_check"} 
														defaultChecked={true}
														onChange={this.checkAllColumns}
														onKeyPress={(e)=>this.validateInput(e)} 
														onBlur={this.removeFocus} style={{marginRight:"5px"}} />
															
												: null
											:null}
										</th>
										<th>Donación</th>
										<th>Fecha</th>
										<th>Volumen</th>
										<th>Código Componente</th>
										<th>Número Componente</th>
										{this.state.cryoprecipitates.blood_components !== undefined ?
											this.state.cryoprecipitates.blood_components.map((c)=>{
												return <th key={c.id} style={{width:"25%"}}>
													<span style={c.component.length > 20 ? {fontSize:'12px'} : {fontSize:'14px'} }>
														<input type="checkbox" name={"all_"+c.id} id={"all_"+c.id} 
															defaultChecked={true}
															onChange={this.checkAllColumns}
															onKeyPress={(e)=>this.validateInput(e)} 
															onBlur={this.removeFocus} style={{marginRight:"5px"}} />
														{c.component}
														
													</span>
												</th>
											})
											
										:null}
									</tr>
								</thead>
								<tbody>
									{this.state.cryoprecipitates.units !== undefined ?
										this.state.cryoprecipitates.units.map((u)=>{
											return u.status.indexOf('RECHAZADA') === -1 ?
												<tr key={u.unit.id}>
													<td>
														<input type="checkbox" name={"unit_"+u.unit.id} id={"unit_"+u.unit.id} 
															onChange={this.clearFields}	defaultChecked={true} 
															onKeyPress={(e)=>this.validateInput(e)} onBlur={this.removeFocus} />
													</td>
													<td>{u.unit.unit_number}</td>
													<td>{moment(u.donation_date).format('DD/MM/YYYY') }</td>
													<td>{u.unit.volume}</td>
													<td>{u.component.code}</td>
													<td>{u.unit.component_number}</td>
													{this.state.cryoprecipitates.blood_components.map((c)=>{
														return <td key={c.id}>
															<span>
																<input type="checkbox" name={'check_'+u.unit.id+'_'+c.id} 
																	id={'check_'+u.unit.id+'_'+c.id} style={{marginRight:"5px"}}
																	defaultChecked={true} checked={true} />
																<input  className="form-control volume-unit" type="number"
																	id={u.unit.id+'_'+c.id}
																	value={c.component_type === 'CRIOPRECIPITADOS' ? u.default_crio_vol:
																		c.component_type === 'PLASMA' ? u.default_pl_vol : ""}
																	onChange={this.changeVolume}
																	style={{display:"inline-block", width:"70%", marginRight:"5px", textAlign:'right'}}
																	onKeyPress={(e) => this.validateInput(e)}
																	/>
																	
																ml
															</span>
														</td>
													})}

												</tr>
											: null
										})
									: null}
								</tbody>
							</Table>
						</div>

						{this.state.search !== 'date' ?
							<div className="col-xs-12 col-sm-11 form-group" style={{marginTop:'10px', textAlign:'center'}}>
								<button className="toolIcon" onClick={this.printLabel}
									disabled={this.state.pending ? true : this.state.units.length === 0}>
									<SvgIcon size={40} icon={priceTag} />
									<div className="col-xs-12">
										<span>Etiqueta</span>
									</div>
								</button>
							</div>
						:null}
					</div>
				</fieldset>

				
			</div>
		)
	}
}

export default Form;